import { FormField, InputField, InputProps, QuestionnaireDescription } from "common";
import { noop } from "lodash";
import React from "react";
import { Field, FieldWithPickupOptions } from "types";

export interface FieldProps extends InputProps {
    name: string;
    field: Field;
    isRequired?: boolean;
    showDescription?: boolean;
    classNames?: {
        label: string;
    };
}
export interface PickupFieldProps extends InputProps {
    name: string;
    field: FieldWithPickupOptions;
    isRequired?: boolean;
    showDescription?: boolean;
    classNames?: {
        label: string;
    };
}

export const TextField = ({ name, field, classNames, showDescription = true, onChange, ...rest }: FieldProps) => {
    return (
        <FormField label={field.label} name={name} classNames={{ label: classNames?.label }}>
            {showDescription && <QuestionnaireDescription field={field} />}
            <InputField onChange={onChange ? (value) => onChange(value) : noop} {...rest} />
        </FormField>
    );
};
